import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Autocomplete, Button, InputLabel, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { updateProduct } from "../../../../../../api/product";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  textAlign: "left",
  height: "auto",
  //   overflowY: "scroll",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  //   backgroundColor:"none",
  padding: "10px 50px",
  borderRadius: "10px",
};

export default function UnableToQuoteModal({savedProduct, isLoading}) {
  const [open, setOpen] = React.useState(false);
  const [selectedReasons, setSelectedReasons] = React.useState([]);
  const [otherReasons, setOtherReasons] = React.useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const navigate = useNavigate()

  const names = [
    "Product is too big",
    "Product is too heavy",
    "Product is powdered",
    "Product is infringing",
    "Product is dangerous",
    "Product has a battery",
    "Product is inflammable",
    "Unable to find a factory"
  ];

  return (
    <>
      {/* <img src={product.img} alt="product"  /> */}
      <Button
        disabled = {isLoading}
        variant="white"
        sx={{ width: "auto", height: "45px" }}
        onClick={handleOpen}
      >
        Unable to Quote
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="hide_scrollbar">
            <h4 style={{ marginBottom: "30px", textAlign: "center" }}>
              Reasons For Unable To Quote
            </h4>

            <InputLabel>Select Options</InputLabel>
            <Autocomplete
              multiple
              id="size-small-outlined-multi"
              // size="small"

              // sx={{height:"46px"}}
              options={names}
              getOptionLabel={(option) => option}
              //   defaultValue={names?.map((name) => name)}
              onChange={(event, value) => {
                setSelectedReasons(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Option"
                  className="hide_scrollbar"
                  sx={{
                    ".MuiOutlinedInput-root": {
                      padding: "0.25rem 0.80rem",
                    },
                    // maxHeight:"100px",
                    overflowY: "scroll",
                  }}
                />
              )}
            />

            <InputLabel style={{ marginTop: "20px" }}>
              Write Other Reasons (Optional)
            </InputLabel>
            <TextField
              rows={6}
              multiline
              placeholder="Write reasons"
              style={{ width: "100%" }}
              onChange={(e) => setOtherReasons(e.target.value)}
            />

            <Button
              variant="deepblue"
              onClick={() => {
                if (savedProduct?._id) {
                  dispatch(
                    updateProduct({
                      productId: savedProduct?._id,
                      updatePayload: {
                        unquotation_reasons: {
                          selected_reasons: selectedReasons,
                          other_reasons: otherReasons || '',
                          // rejected_variants:selectedRowsForRejection
                        },
                        quotation_type:"unable to quote",
                        status:"failed"
                      },
                    })
                  );
                  navigate(-1);
                }
              }}
            >
              Save
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
